<div class="modal-content" cdkTrapFocus [cdkTrapFocusAutoCapture]="false">
  <div class="modal-header">
    <h1 class="modal-title pull-left" id="my-modal-title" [innerHtml]="title | globalTranslate | sanitize "></h1>
    <button type="button" class="btn-close pull-right" [attr.aria-label]="'CLOSE' | globalTranslate" (click)="onCancel()">
      <img src="../../assets/images/⚛️ icons-close-circle-outline.svg" alt="close-icon" />
    </button>
  </div>
  <div class="modal-body">
    <p [innerHtml]="'CONFIRM_OPEN_APPEAL_1' | globalTranslate | sanitize " class="pb-2 pt-2"></p>
  </div>
  <div class="modal-footer" style="justify-content: flex-start;">
    <div class="me-2 ml-2">
      <button type="button" id="dialog" class="btn btn-secondary"  (click)="onConfirm()" [ngClass]="{'font-translate': decreaseFont()}">{{
        'CONFIRM_OPEN_APPEAL_2' | globalTranslate }}</button>
    </div>
    <div class="me-2 ml-2">
      <button type="button" id="dialog" class="btn btn-link" (click)="onCancel()" [ngClass]="{'font-translate': decreaseFont()}">{{
        'CONFIRM_OPEN_APPEAL_3' | globalTranslate }}</button>
    </div>
  </div>
</div>